import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerWorkOrderVersionObjectTotals } from '../workOrderVersionQueries';

const requestId = 'uerWorkOrderVersionObjectTotals';

export const useUerWorkOrderVersionObjectTotals = () => {
    const dispatch = useDispatch();

    const [uerWorkOrderVersionObjectTotalsReset] = useResetStoreData({ requestId });

    const [
        uerWorkOrderVersionObjectTotalsData,
        uerWorkOrderVersionObjectTotalsStatus,
        ,
        uerWorkOrderVersionObjectTotalsRequest,
    ] = useRequest({
        requestId,
        query: uerWorkOrderVersionObjectTotals,
        withEffect: false,
    });

    const uerWorkOrderObjectTotalsMakeRequest = useCallback(
        (workOrderVersionId: number, workOrderVersionObjectId: number) => {
            uerWorkOrderVersionObjectTotalsReset(undefined);
            dispatch(
                uerWorkOrderVersionObjectTotalsRequest({
                    workOrderVersionId,
                    workOrderVersionObjectId,
                }),
            );
        },
        [dispatch, uerWorkOrderVersionObjectTotalsRequest, uerWorkOrderVersionObjectTotalsReset],
    );

    return {
        uerWorkOrderVersionObjectTotalsData,
        uerWorkOrderVersionObjectTotalsStatus,
        uerWorkOrderObjectTotalsMakeRequest,
    };
};
